$('.js-load-more').on('click', function(){
    var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');
    $this.find('[load-more-text]').addClass('hide'); 
    currentPage = currentPage+1;
    var nextUrl = $('[data-next-url]').data().nextUrl.replace(/page=[0-9]+/,'page='+currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('.product-list').append($(responseHTML).find('.product-list').html());
      },
      complete: function() {
        if(currentPage <= totalPages) {
           $this.attr('disabled', false); 
           $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        } 
      }
    })
  });